import { saveBlob } from '../../api/members';
import { isIOS } from '../../lib/standalone';
import { buildVCard, vcardFilename, type VCardInput } from './vcard';

/**
 * Hand a vCard to the device: on iPad/iPhone/Android the share sheet (which offers Contacts);
 * elsewhere a .vcf download. Resolves false when the user dismissed the share sheet.
 */
export async function shareOrDownloadVCard(input: VCardInput): Promise<boolean> {
  const text = buildVCard(input);
  const name = vcardFilename(input.fullName);
  const type = 'text/vcard;charset=utf-8';
  const blob = new Blob([text], { type });
  const mobile = isIOS() || /Android/i.test(navigator.userAgent);

  if (mobile && typeof navigator.canShare === 'function' && typeof File === 'function') {
    const file = new File([blob], name, { type });
    if (navigator.canShare({ files: [file] })) {
      try {
        await navigator.share({ files: [file] });
        return true;
      } catch (e) {
        if ((e as Error)?.name === 'AbortError') return false;
        // NotAllowedError etc. → fall back to a download below.
      }
    }
  }
  saveBlob(blob, name);
  return true;
}
